import { render } from "./UserScienceIdDialog.vue?vue&type=template&id=5c5ad5d5&scoped=true"
import script from "./UserScienceIdDialog.vue?vue&type=script&lang=js"
export * from "./UserScienceIdDialog.vue?vue&type=script&lang=js"

import "./UserScienceIdDialog.vue?vue&type=style&index=0&id=5c5ad5d5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5ad5d5"]])

export default __exports__